var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.456,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1350",
    d: "M24.531 21H4.925A4.957 4.957 0 010 16.075V4.925A4.957 4.957 0 014.925 0h19.606a4.957 4.957 0 014.925 4.925v11.15A4.957 4.957 0 0124.531 21zM4.925 1.487a3.471 3.471 0 00-3.531 3.531v11.15A3.471 3.471 0 004.925 19.7h19.606a3.471 3.471 0 003.531-3.531V4.925a3.471 3.471 0 00-3.531-3.531H4.925zm7.34 14.213a.559.559 0 01-.372-.093.933.933 0 01-.558-.929V5.2a.976.976 0 01.465-.836 1.278 1.278 0 011.022-.093l7.341 4.739a.871.871 0 01.465.836.893.893 0 01-.558.836l-7.155 4.646a.805.805 0 01-.65.372zm.465-9.757v7.991l6.133-4zm6.6 4.274zm0-.65z",
    fill: "#555"
  })));
}

export default __webpack_public_path__ + "static/media/youtube_sm.9a84d63a6526102f2884fee6fa4aa6cf.svg";
export { SvgYoutubeSm as ReactComponent };